var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4217 5.21072C11.5844 5.21072 12.5269 4.26812 12.5269 3.10536C12.5269 1.9426 11.5844 1 10.4217 1C9.25897 1 8.31641 1.9426 8.31641 3.10536C8.31641 4.26812 9.25897 5.21072 10.4217 5.21072Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4212 19.0008C11.1188 19.0008 11.6843 18.4353 11.6843 17.7377C11.6843 17.0401 11.1188 16.4746 10.4212 16.4746C9.72368 16.4746 9.1582 17.0401 9.1582 17.7377C9.1582 18.4353 9.72368 19.0008 10.4212 19.0008Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24839 7.14148C6.29491 7.14148 7.14327 6.29308 7.14327 5.24652C7.14327 4.19996 6.29491 3.35156 5.24839 3.35156C4.20188 3.35156 3.35352 4.19996 3.35352 5.24652C3.35352 6.29308 4.20188 7.14148 5.24839 7.14148Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5946 16.6483C16.176 16.6483 16.6473 16.177 16.6473 15.5956C16.6473 15.0143 16.176 14.543 15.5946 14.543C15.0133 14.543 14.542 15.0143 14.542 15.5956C14.542 16.177 15.0133 16.6483 15.5946 16.6483Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10568 12.106C4.03562 12.106 4.78948 11.3521 4.78948 10.4222C4.78948 9.49218 4.03562 8.73828 3.10568 8.73828C2.17574 8.73828 1.42188 9.49218 1.42188 10.4222C1.42188 11.3521 2.17574 12.106 3.10568 12.106Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.738 11.2633C18.2028 11.2633 18.5796 10.8865 18.5796 10.4217C18.5796 9.95687 18.2028 9.58008 17.738 9.58008C17.2733 9.58008 16.8965 9.95687 16.8965 10.4217C16.8965 10.8865 17.2733 11.2633 17.738 11.2633Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20629 14.5556C3.63045 15.1314 3.63045 16.0632 4.20629 16.6391C4.78145 17.2149 5.71455 17.2149 6.2897 16.6391C6.86554 16.0632 6.86554 15.1314 6.2897 14.5556C5.71455 13.979 4.78214 13.9735 4.20629 14.5556Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5941 5.87958C15.9426 5.87958 16.2252 5.59699 16.2252 5.24839C16.2252 4.89978 15.9426 4.61719 15.5941 4.61719C15.2455 4.61719 14.9629 4.89978 14.9629 5.24839C14.9629 5.59699 15.2455 5.87958 15.5941 5.87958Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonSpinner);
export default __webpack_public_path__ + "static/media/buttonSpinner.e4960bdf01d7a7f2e6de11d634acd4e9.svg";
export { ForwardRef as ReactComponent };